import type { Column } from "@tanstack/react-table";

/**
 * Ustun nomi — ko'rinish ro'yxati, filtr chiplari va skrinrider uchun.
 * Sarlavha JSX bo'lishi mumkin, shuning uchun avval `meta.label`.
 */
export function columnName<TData>(column: Column<TData, unknown>): string {
  const header = column.columnDef.header;
  return column.columnDef.meta?.label ?? (typeof header === "string" ? header : column.id);
}

/** Ustun ma'lumot emas, qatorning o'zi (amallar) — yashirib bo'lmaydi. */
export function isStructural<TData>(column: Column<TData, unknown>): boolean {
  return column.id === "actions" || !column.getCanHide();
}
